(function() {
  class $e9a80e964f7af9ac$var$FilterMenu extends HTMLElement {
    constructor() {
      super();
      this.buttons = [];
      this.summary = null;
      this.details = null;
      this.detailsDisclosure = null;
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onSummaryKeyDown = this.onSummaryKeyDown.bind(this);
      this.updateButtons = this.updateButtons.bind(this);
    }
    connectedCallback() {
      this.details = this.closest("details");
      this.detailsDisclosure = this.closest("details-disclosure");
      this.summary = this.details ? this.details.querySelector("summary") : null;
      this.updateButtons();
      this.addEventListener("keydown", this.onKeyDown);
      if (this.summary) this.summary.addEventListener("keydown", this.onSummaryKeyDown);
      this.observer = new MutationObserver(mutations => {
        const hasNodeChanges = mutations.some(mutation => mutation.type === "childList");
        if (hasNodeChanges) {
          this.updateButtons();
          this.restoreFocus();
        }
      });
      this.observer.observe(this, {
        childList: true,
        subtree: true
      });
    }
    disconnectedCallback() {
      this.removeEventListener("keydown", this.onKeyDown);
      if (this.summary) this.summary.removeEventListener("keydown", this.onSummaryKeyDown);
      if (this.observer) this.observer.disconnect();
    }
    updateButtons() {
      this.buttons = Array.from(this.querySelectorAll("[data-button]"));
      if (!this.buttons.length) return;
      this.initAccessibility();
    }
    restoreFocus() {
      if (!this.details.hasAttribute("open")) return;
      if (document.activeElement === document.body) this.focusItem(0);
    }
    initAccessibility() {
      this.buttons.forEach((btn, index) => {
        if (index === 0) btn.setAttribute("tabindex", "0"); else btn.setAttribute("tabindex", "-1");
      });
    }
    onSummaryKeyDown(event) {
      if (event.key === "ArrowDown" && this.details.hasAttribute("open")) {
        event.preventDefault();
        if (this.buttons.length > 0) this.focusItem(0);
      }
    }
    onKeyDown(event) {
      if (this.buttons.length === 0) return;
      const currentIndex = this.buttons.indexOf(document.activeElement);
      if (currentIndex === -1) return;
      switch (event.key) {
       case "Escape":
        event.preventDefault();
        this.closeMenu();
        break;

       case "ArrowDown":
        event.preventDefault();
        this.focusNextItem(currentIndex);
        break;

       case "ArrowUp":
        event.preventDefault();
        this.focusPrevItem(currentIndex);
        break;

       case "Home":
        event.preventDefault();
        this.focusItem(0);
        break;

       case "End":
        event.preventDefault();
        this.focusItem(this.buttons.length - 1);
        break;

       case "Enter":
       case " ":
        event.preventDefault();
        this.buttons[currentIndex].click();
        break;
      }
    }
    closeMenu() {
      if (this.details && this.details.hasAttribute("open")) {
        if (this.detailsDisclosure) this.detailsDisclosure.close(); else this.details.removeAttribute("open");
        if (this.summary) {
          this.summary.focus();
          if (!this.detailsDisclosure) this.summary.setAttribute("aria-expanded", "false");
        }
      }
    }
    focusNextItem(currentIndex) {
      const nextIndex = currentIndex + 1 < this.buttons.length ? currentIndex + 1 : 0;
      this.focusItem(nextIndex);
    }
    focusPrevItem(currentIndex) {
      const prevIndex = currentIndex - 1 >= 0 ? currentIndex - 1 : this.buttons.length - 1;
      this.focusItem(prevIndex);
    }
    focusItem(index) {
      const button = this.buttons[index];
      if (!button) return;
      this.buttons.forEach(btn => btn.setAttribute("tabindex", "-1"));
      button.setAttribute("tabindex", "0");
      button.focus();
      button.scrollIntoView({
        block: "nearest"
      });
    }
  }
  if (!customElements.get("filter-menu")) customElements.define("filter-menu", $e9a80e964f7af9ac$var$FilterMenu);
})();